import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewContainerRef, NO_ERRORS_SCHEMA } from '@angular/core';
import { LoggerService } from '../../shared/logger.service';
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthTokenService } from '../../auth/auth-token.service';
import {
  faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { ButtonsModule } from "@progress/kendo-angular-buttons";
// import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { WindowModule } from "@progress/kendo-angular-dialog";
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { UserDataService } from '../user-data.service';
import { NotificationService, NotificationModule } from "@progress/kendo-angular-notification";
import { CasiCloseOptions, PHONE_REGEX_V2 } from '../../common/constants.lib';
import { ToastrService } from 'ngx-toastr';
import { casiNotify } from '../../common/utils.lib';
import { CasiToastrService } from '../../shared/casi-toastr.service';

import { all } from '@awesome.me/kit-787edf9aa0/icons';
import {
  confirmedPasswordValidator, firstOrLastName2RequiredValidator,
  firstOrLastName3RequiredValidator
} from '../../directives/casi.validators';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    FontAwesomeModule,
    RouterLink, RouterLinkActive,
    InputsModule,
    ButtonsModule,
    DialogsModule,
    WindowModule,
    NotificationModule,
    ChangePasswordComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit, OnDestroy {

  // @ViewChild("appendTo", { read: ViewContainerRef, static: false }) appendTo: ViewContainerRef;
  // @ViewChild("appendTo", { read: ViewContainerRef }) appendTo: ViewContainerRef | undefined;

  form: FormGroup;

  user: any = null;

  public opened: boolean = false;
  public dataSaved: boolean = false;
  public errorOpened: boolean = false;

  private _subs: Subscription[] = [];

  constructor(private logger: LoggerService,
    public authTokenService: AuthTokenService,
    private fb: FormBuilder,
    public faIcons: FaIconLibrary,
    private dataService: UserDataService,
    private notificationService: NotificationService,
    private toastr: ToastrService
  ) {
    faIcons.addIcons(faTriangleExclamation);
    faIcons.addIcons(...all);
    this.form = this.fb.group({
      userId: [null, []],
      firstName: [null],
      lastName: [null],
      email: [null, [Validators.required, Validators.email]],
      researchConsent: [null, []],
      phone: [null, [Validators.pattern(PHONE_REGEX_V2)]],
      newsletter: [null, []]
    },
      {
        validators: [
          // firstOrLastName2RequiredValidator
          firstOrLastName3RequiredValidator('firstName', 'lastName')
        ]
      });
    // this.logger.debug(`contructor:form: `, this.form);

  }

  get f() {
    return this.form.controls;
  }
  get email() {
    return this.form.get('email');
  }
  get firstName() {
    return this.form.get('firstName');
  }
  get lastName() {
    return this.form.get('lastName');
  }
  get researchConsent() {
    return this.form.get('researchConsent');
  }
  get phone() {
    return this.form.get('phone');
  }

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.initForm();
    this.email?.valueChanges.subscribe(value => {
      if (value && value !== value.toLowerCase()) {
        this.email?.setValue(value.toLowerCase(), { emitEvent: false });
      }
    });
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  onSubmit(): void {
    this.logger.debug('onSubmit...form.value', this.form.value);
    let val = this.form.value;
    let toSubmit = {
      first_name: val.firstName,
      last_name: val.lastName,
      email: val.email,
      research_consent: val.researchConsent,
      id: val.userId,
      phone: val.phone,
      newsletter: val.newsletter
    };
    this.logger.debug('onSubmit:toSubmit', toSubmit);
    this.dataService.updateUserProfile(toSubmit)
      .then(resp => {
        this.logger.debug('onSubmit:resp:', resp);
        this.authTokenService.setToken(resp);
        this.notify("Profile Updated");
      })
      .catch(err => {
        this.logger.error('onSubmit:error', err);
        const emailAlreadyInUse = err.status === 409;
        if (emailAlreadyInUse) {
          val.email = this.user.email;
          this.form.patchValue(val);
          this.errorOpened = true;
        }
        else
          this.notify("An error cccurred when saving the record", true);
      })
  }

  cancelProfile() {
    this.logger.debug('cancelProfile...');
    this.initForm();
  }

  handleClose() {
    this.logger.debug('handleClose...');
    this.opened = false;
  }
  // public close(status: string): void {
  //   console.log(`Dialog result: ${status}`);
  //   this.opened = false;
  // }

  public close(args: any): void {
    this.logger.debug('close...', args);
    this.opened = false;
    if (args === CasiCloseOptions.Saved)
      this.notify("Password Updated");
  }

  public open(): void {
    this.logger.debug('open...');
    this.opened = true;
  }

  public openError(): void {
    this.logger.debug('openError...');
    this.errorOpened = true;
  }

  // public submit(): void {
  //   this.logger.debug('submit...');
  //   this.dataSaved = true;
  //   this.close();
  // }

  public errorClose(status: string): void {
    this.logger.debug('errorClose:status: ', status);
    this.errorOpened = false;
  }

  private initForm() {
    this.user = this.authTokenService.userComputed(); //.getClaims();
    this.logger.debug('initForm...', this.user);
    this.form.patchValue({ ...this.user });
  }

  private notify(msg: string, error: boolean = false): void {
    this.logger.debug("notify", msg);
    if (error) {
      this.toastr.error(msg, 'Error');
    } else {
      this.toastr.success(msg);
    }
    // this.notificationService.show({
    //   appendTo: this.appendTo,
    //   content: msg,
    //   animation: { type: "fade", duration: 300 },
    //   type: { style: !error ? "success" : "error", icon: true },
    //   position: {
    //     horizontal: "right",
    //     vertical: "top"
    //   },
    //   height: 50,
    //   // width: 150,
    //   hideAfter: 2000
    // });
  }
}
